import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { TranslateModule } from '@ngx-translate/core';
// Components
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/layout/content/content.component';
import { FullComponent } from './components/layout/full/full.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
// Header Elements Components
import { SearchComponent } from './components/header/elements/search/search.component';
import { MegaMenuComponent } from './components/header/elements/mega-menu/mega-menu.component';
import { LanguagesComponent } from './components/header/elements/languages/languages.component';
import { NotificationComponent } from './components/header/elements/notification/notification.component';
import { BookmarkComponent } from './components/header/elements/bookmark/bookmark.component';
import { CartComponent } from './components/header/elements/cart/cart.component';
import { MessageBoxComponent } from './components/header/elements/message-box/message-box.component';
import { MyAccountComponent } from './components/header/elements/my-account/my-account.component';
// Directives
import { DisableKeyPressDirective } from './directives/disable-key-press.directive';
import { OnlyAlphabetsDirective } from './directives/only-alphabets.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { ShowOptionsDirective } from './directives/show-options.directive';
// Services
import { ChatService } from './services/chat.service';
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { TableService } from './services/table.service';
import { NgbdSortableHeader } from './directives/NgbdSortableHeader';
import { DecimalPipe } from '@angular/common';
import { ToDateOnlyPipe } from './_helper/to-date-only.pipe';
import { ToDateLargePipe } from './_helper/to-date-large.pipe';
import { ToDateTimePipe } from './_helper/to-date-time.pipe';
import { ToTimeOnlyPipe } from './_helper/to-time-only.pipe';
import { NgxHijriGregorianDatepickerModule } from './components/date-picker/ngx-hijri-gregorian-datepicker.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgSelectModule } from '@ng-select/ng-select';
import { SignComponent } from './components/sign/sign.component';
import { GeneralAttachmentComponent } from './components/general-attachment/general-attachment.component';
import { BrowserModule } from '@angular/platform-browser';
import { CustomToggleThreeComponent } from './components/custom-toggle-three/custom-toggle-three.component';
import { CustomToggleComponent } from './components/custom-toggle/custom-toggle.component';
import { ScannerComponent } from './components/scanner/scanner.component';
import { GoogleMapsModule } from "@angular/google-maps";
import { ProfileComponent } from './components/profile/profile.component';
import { CompanyViolationComponent } from './components/company-violation/company-violation.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { GeneralViolationsComponent } from './components/general-violations/general-violations.component';
import { ViolationDetailsComponent } from './components/violation-details/violation-details.component';
import { SizeOfStringPipe } from './_helper/size-of-string.pipe';



@NgModule({
  declarations: [
        HeaderComponent, CustomToggleComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    CustomizerComponent,
        FeatherIconsComponent, CustomToggleThreeComponent,
    FullComponent,
    ShowOptionsDirective,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    MegaMenuComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    NgbdSortableHeader,
        ToDateOnlyPipe, ToTimeOnlyPipe, ToDateTimePipe, SignComponent, GeneralAttachmentComponent, ToDateLargePipe,  CustomToggleComponent,
      ScannerComponent, ProfileComponent, CompanyViolationComponent, CompanyDetailsComponent, GeneralViolationsComponent, ViolationDetailsComponent, SizeOfStringPipe
 ],
  imports: [
CommonModule,
      RouterModule, 
      FormsModule, 
    ReactiveFormsModule,
    NgSelectModule,PdfViewerModule,
    NgbModule,
    DragulaModule.forRoot(),
      TranslateModule, NgxHijriGregorianDatepickerModule, 
      GoogleMapsModule,
  ],
  providers: [
    NavService,
    ChatService,
    LayoutService,
    TableService,
    DecimalPipe
  ],
  exports: [
    NgbModule,
    FormsModule,
      ReactiveFormsModule, CustomToggleThreeComponent,
    TranslateModule,PdfViewerModule,
    LoaderComponent,
      BreadcrumbComponent,
    FeatherIconsComponent,
    TapToTopComponent,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    NgbdSortableHeader,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CustomizerComponent,
    ToDateOnlyPipe, ToTimeOnlyPipe,
    ToDateTimePipe, NgxHijriGregorianDatepickerModule,
      CompanyViolationComponent, ToDateLargePipe, CompanyDetailsComponent, GeneralViolationsComponent, ViolationDetailsComponent, SizeOfStringPipe, ScannerComponent
    
],
})
export class SharedModule { }
